module.exports = __webpack_public_path__ + "img/Babies.bd615dd5.svg";